import script from "./GuideViewNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./GuideViewNew.vue?vue&type=script&lang=ts&setup=true"

import "./GuideViewNew.vue?vue&type=style&index=0&id=a074e64c&scoped=true&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.34_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a074e64c"]])

export default __exports__